import { useCallback, useMemo, type RefObject } from 'react';
import { AtomicItemListType, type IScreensComponent } from 'shared/src/api';
import type { AtomicRendererRefCurrent } from '../HomeAtomic';

type UseScrollAfterFetchProps = {
  components: Array<IScreensComponent> | undefined;
  atomicRendererRef: RefObject<AtomicRendererRefCurrent | null>;
};

export const useScrollToFilterList = ({
  atomicRendererRef,
  components,
}: UseScrollAfterFetchProps) => {
  const filterListIndex = useMemo(
    () =>
      components?.findIndex(
        component => component.type.itemList === AtomicItemListType.FilterList,
      ),
    [components],
  );

  const formattedFilterListIndex = useMemo(() => {
    return filterListIndex === -1 ? undefined : filterListIndex;
  }, [filterListIndex]);

  const scrollToFilterList = useCallback(() => {
    if (!formattedFilterListIndex) {
      return;
    }

    // FilterList아토믹으로 이동할 경우 높이를 잡지 못하는 이슈가 있음
    // 따라서 formattedFilterListIndex -1만큼 이동하고, viewOffset으로 Divider 아토믹 높이만큼 올림
    const DIVIDER_ATOMIC_HEIGHT = 8;

    atomicRendererRef.current?.scrollToIndex({
      index: formattedFilterListIndex - 1,
      animated: true,
      viewOffset: -DIVIDER_ATOMIC_HEIGHT,
    });
  }, [formattedFilterListIndex, atomicRendererRef]);

  return {
    scrollToFilterList,
    filterListIndex: formattedFilterListIndex,
  };
};
